import {BaseDomainService} from "../../../infrastructure/domain-services/base-domain-service";
import {BaseManagedService} from "../../../infrastructure/domain-services/base-managed-service";
import {DomainRequestManager} from "../../../core/managers/domain-request-manager";
import {PartialGameRepository} from "./partial-game.repository";
import {PartialGameFactory} from "./partial-game.factory";

export class PartialGameDomainService extends BaseDomainService {
  static injectables = [...BaseManagedService.injectables, PartialGameRepository, PartialGameFactory, DomainRequestManager];
}
